import React from 'react'
import { formatDate } from './admitCardHelpers'

/** Shared printable admit card (used by /student/:id/admit-card and /ExamSheet/Admitcard). */
export default function AdmitCardPrintView({
  admitCardRef,
  student,
  courseName,
  className,
  instituteName,
  examName = '',
  sessionName,
  instituteLogoSrc,
  examRows,
  examLocation = '',
}) {
  const subjectRows = Array.isArray(examRows) ? examRows : []

  return (
    <>
      <style>
        {`
          .admit-page { max-width: 920px; margin: 24px auto; padding: 0 16px; }
          .admit-toolbar { display: flex; justify-content: flex-end; margin-bottom: 12px; gap: 8px; }
          .admit-main-wrap {
            transition: margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            z-index: 1;
            padding-left: 12px;
            padding-right: 12px;
          }
          .admit-top-header {
            margin-top: -12px;
            border-bottom: 1px solid #d1d3d4;
            background: #f3f4f6;
            padding: 12px 28px;
            width: 100%;
          }
          .admit-top-header-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
          }
          .admit-title-wrap {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .admit-header-logo {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            background: #223843;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
          .admit-card-root {
            border: none;
            border-radius: 10px;
            background: #fff;
            padding: 16px 18px;
            position: relative;
            overflow: visible;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          }
          .admit-watermark-logo-wrapper {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 72%;
            max-width: 420px;
            opacity: 0.2;
            z-index: 0;
            pointer-events: none;
          }
          .admit-watermark-logo {
            width: 100%;
            height: auto;
            object-fit: contain;
            object-position: center;
          }
          .admit-card-root > *:not(.admit-watermark-logo-wrapper):not(.admit-watermark-logo) {
            position: relative;
            z-index: 1;
          }
          .admit-header {
            display: grid;
            grid-template-columns: 90px 1fr;
            align-items: center;
            gap: 12px;
            border-bottom: 2px solid #111827;
            padding-bottom: 12px;
            margin-bottom: 12px;
          }
          .admit-header-exam-name {
            margin: 2px 0 0;
            text-align: center;
            font-size: 13px;
            font-weight: 600;
            line-height: 1.25;
            word-break: break-word;
          }
          .admit-header-session {
            margin: 2px 0 0;
            text-align: center;
            font-size: 12px;
            line-height: 1.25;
          }
          .admit-logo {
            width: 84px;
            height: 84px;
            border: 1px solid #d1d5db;
            border-radius: 50%;
            object-fit: cover;
            background: #f8fafc;
          }
          .student-photo {
            width: 110px;
            height: 130px;
            object-fit: cover;
            border: 1px solid #111827;
            border-radius: 6px;
            justify-self: end;
          }
          .detail-grid {
            display: grid;
            grid-template-columns: 1fr 1fr 160px;
            gap: 10px 16px;
            margin-top: 10px;
            margin-bottom: 14px;
          }
          .detail-photo-item {
            grid-column: 3;
            grid-row: 1 / span 4;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px;
          }
          .detail-photo-item img {
            width: 130px;
            height: 160px;
            object-fit: cover;
            border: 1px solid #111827;
            border-radius: 4px;
          }
          .detail-item {
            padding: 8px 10px;
            font-size: 13px;
          }
          .detail-item-full {
            grid-column: 1 / -1;
            white-space: nowrap;
          }
          .detail-item strong { margin-right: 6px; }
          .admit-section-title {
            margin: 0 0 8px;
            font-size: 14px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.4px;
          }
          .exam-table {
            width: 100%;
            max-width: 100%;
            border-collapse: collapse;
            margin-bottom: 14px;
            font-size: 12px;
            table-layout: fixed;
            box-sizing: border-box;
          }
          .exam-table th, .exam-table td {
            border: 1px solid #111827;
            padding: 5px 6px;
            text-align: left;
            vertical-align: top;
            box-sizing: border-box;
            overflow-wrap: anywhere;
            word-break: break-word;
          }
          .exam-table th { background: #f3f4f6; }
          .exam-table col.col-sr { width: 8%; }
          .exam-table col.col-subject { width: 26%; }
          .exam-table col.col-paper-type { width: 24%; }
          .exam-table col.col-date { width: 18%; }
          .exam-table col.col-time { width: 24%; }
          .exam-table th:nth-child(1),
          .exam-table td:nth-child(1) {
            text-align: center;
            white-space: nowrap;
            overflow-wrap: normal;
            word-break: normal;
          }
          .exam-table th:nth-child(4),
          .exam-table td:nth-child(4) {
            white-space: nowrap;
            overflow-wrap: normal;
            word-break: normal;
          }
          .admit-date-value { font-weight: 600; }
          .exam-table thead { display: table-header-group; }
          .exam-table tr { page-break-inside: avoid; break-inside: avoid; }
          .no-break { page-break-inside: avoid; break-inside: avoid; }
          .page-break { page-break-before: always; break-before: page; }
          .instruction-list {
            margin: 0;
            padding-left: 20px;
            font-size: 12.5px;
            line-height: 1.5;
          }
          .admit-footer {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
            margin-top: 18px;
            text-align: center;
          }
          .sign-box {
            border-top: 1px solid #111827;
            padding-top: 6px;
            margin-top: 20px;
            min-height: 44px;
            font-size: 12.5px;
          }
          .meta-row {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            margin-bottom: 10px;
            font-size: 12px;
          }
          .exam-center-note {
            margin-top: 8px;
            border: 1px solid #d1d5db;
            border-radius: 6px;
            padding: 8px;
            font-size: 12px;
          }
          @media (max-width: 768px) {
            .admit-top-header { margin-top: 55px; padding: 12px 16px; }
            .admit-page { padding-left: 8px; padding-right: 8px; }
            .admit-card-root {
              padding: 12px 8px;
              overflow-x: auto;
              -webkit-overflow-scrolling: touch;
            }
            .admit-watermark-logo-wrapper {
              opacity: 0.1;
              width: 78%;
            }
            .admit-header { grid-template-columns: 56px 1fr; gap: 8px; }
            .admit-logo { width: 56px; height: 56px; }
            .admit-header h4 { font-size: 14px !important; }
            .admit-header h5 { font-size: 12px !important; margin: 4px 0 0 !important; }
            .admit-header-exam-name { font-size: 11px; }
            .admit-header-session { font-size: 11px; }
            .student-photo { grid-column: 1 / -1; justify-self: start; }
            .detail-grid {
              grid-template-columns: minmax(0, 1fr) 92px;
              gap: 4px 10px;
              margin-top: 8px;
              margin-bottom: 10px;
              align-items: start;
            }
            .detail-photo-item {
              grid-column: 2;
              grid-row: 1 / span 6;
              justify-content: flex-end;
              align-items: flex-start;
              padding: 0;
            }
            .detail-photo-item img {
              width: 88px;
              height: 108px;
            }
            .detail-item {
              grid-column: 1;
              margin-top: 0 !important;
              padding: 4px 2px;
              font-size: 12px;
            }
            .detail-item-full {
              grid-column: 1 / -1;
              white-space: normal !important;
            }
            .exam-table {
              min-width: 520px;
              width: 100%;
              font-size: 11px;
              margin-bottom: 12px;
            }
            .exam-table th,
            .exam-table td {
              padding: 5px 4px;
              white-space: normal !important;
              overflow-wrap: anywhere;
              word-break: break-word;
            }
            .exam-table col.col-sr { width: 9%; }
            .exam-table col.col-subject { width: 26%; }
            .exam-table col.col-paper-type { width: 18%; }
            .exam-table col.col-date { width: 22%; }
            .exam-table col.col-time { width: 25%; }
            .exam-table th:nth-child(1),
            .exam-table td:nth-child(1),
            .exam-table th:nth-child(4),
            .exam-table td:nth-child(4) {
              white-space: normal !important;
              overflow-wrap: anywhere;
              word-break: break-word;
            }
            .admit-section-title { font-size: 13px; }
            .instruction-list {
              padding-left: 18px;
              font-size: 12px;
            }
            .admit-footer { grid-template-columns: 1fr; gap: 8px; }
          }
          @media print {
            @page { size: A4; margin: 12mm 18mm 12mm 12mm; }
            body { background: #fff; }
            .admit-toolbar, .sidebar, nav, .no-print { display: none !important; }
            .admit-top-header { display: none !important; }
            .admit-page { margin: 0; padding: 0; max-width: 100%; }
            .admit-card-root {
              box-shadow: none;
              border-radius: 0;
              padding: 10px 8mm 10px 10px;
              border: none;
              overflow: visible !important;
              page-break-inside: auto;
              break-inside: auto;
              box-sizing: border-box;
              width: 100%;
              max-width: 100%;
            }
            .admit-watermark-logo-wrapper {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              height: 100% !important;
              max-width: none !important;
              transform: none !important;
              opacity: 0.2 !important;
              z-index: 0 !important;
            }
            .admit-watermark-logo {
              width: 100% !important;
              height: 100% !important;
              object-fit: contain !important;
            }
            .admit-card-root > *:not(.admit-watermark-logo-wrapper):not(.admit-watermark-logo) {
              position: relative !important;
              z-index: 1 !important;
            }
            .exam-table {
              page-break-inside: auto;
              break-inside: auto;
              width: 100%;
              max-width: 100%;
              table-layout: fixed;
              border-collapse: collapse;
              box-sizing: border-box;
              font-size: 11px;
            }
            .exam-table thead { display: table-header-group; }
            .exam-table tr { page-break-inside: avoid; break-inside: avoid; }
            .exam-table th, .exam-table td {
              padding: 4px 5px;
              vertical-align: top;
              box-sizing: border-box;
              overflow-wrap: anywhere;
              word-break: break-word;
            }
            .exam-table th:nth-child(1),
            .exam-table td:nth-child(1) {
              white-space: nowrap;
              overflow-wrap: normal;
              word-break: normal;
            }
            .exam-table th:nth-child(4),
            .exam-table td:nth-child(4) {
              white-space: nowrap;
              overflow-wrap: normal;
              word-break: normal;
            }
            .exam-table th:nth-child(3),
            .exam-table td:nth-child(3),
            .exam-table th:nth-child(5),
            .exam-table td:nth-child(5) {
              white-space: normal;
            }
            .instruction-list { line-height: 1.4; }
            .admit-header { padding-bottom: 8px; margin-bottom: 8px; gap: 10px; }
            .admit-header h4 { font-size: 16px !important; }
            .admit-header h5 { font-size: 13px !important; margin: 4px 0 0 !important; }
            .admit-header-exam-name { font-size: 12px !important; margin: 2px 0 0 !important; }
            .admit-header-session { font-size: 11px !important; margin: 1px 0 0 !important; }
            .no-break { page-break-inside: avoid; break-inside: avoid; }
            .page-break {
              page-break-before: always;
              break-before: page;
              padding-top: 10mm;
            }
            .admit-instructions {
              page-break-inside: avoid;
              break-inside: avoid;
            }
          }
        `}
      </style>

      <div className="admit-card-root" ref={admitCardRef}>
        <div className="admit-watermark-logo-wrapper" aria-hidden="true">
          <img
            src={instituteLogoSrc}
            alt=""
            className="admit-watermark-logo"
            onError={(e) => {
              e.currentTarget.onerror = null
              e.currentTarget.src = `${process.env.PUBLIC_URL || ''}/markWatermark.png`
            }}
          />
        </div>
        <div className="admit-header no-break">
          <img
            src={instituteLogoSrc}
            alt="School Logo"
            className="admit-logo"
            onError={(e) => {
              e.currentTarget.onerror = null
              e.currentTarget.src = `${process.env.PUBLIC_URL || ''}/logo192.png`
            }}
          />
          <div>
            <h4 style={{ margin: 0, fontWeight: 700, textAlign: 'center' }}>{instituteName}</h4>
            <h5 style={{ margin: '6px 0 2px', textAlign: 'center' }}>Examination Admit Card</h5>
            {examName ? (
              <p className="admit-header-exam-name">Exam: {examName}</p>
            ) : null}
            {sessionName ? (
              <p className="admit-header-session">Session: {sessionName}</p>
            ) : null}
          </div>
        </div>

        <div className="detail-grid text-start no-break">
          <div className="detail-item">
            <strong>Student Name:</strong>
            {student?.name || ''}
          </div>
          <div className="detail-item">
            <strong>Father&apos;s Name:</strong>
            {student?.father_name || ''}
          </div>
          <div className="detail-photo-item">
            <img src={student?.student_image || ''} alt="" />
          </div>
          <div className="detail-item" style={{ marginTop: '-1.2em' }}>
            <strong>Course:</strong>
            {courseName}
          </div>
          <div className="detail-item" style={{ marginTop: '-1.2em' }}>
            <strong>Class:</strong>
            {className}
          </div>
          <div className="detail-item" style={{ marginTop: '-1.2em' }}>
            <strong>Roll Number:</strong>
            {student?.roll_number || ''}
          </div>
          <div className="detail-item" style={{ marginTop: '-1.2em' }}>
            <strong>Admission Number:</strong>
            {student?.admission_number || ''}
          </div>
          <div className="detail-item" style={{ marginTop: '-1.2em' }}>
            <strong>Gender:</strong>
            {student?.gender
              ? `${student.gender.charAt(0).toUpperCase()}${student.gender.slice(1)}`
              : ''}
          </div>
          <div className="detail-item" style={{ marginTop: '-1.2em' }}>
            <strong>Date of Birth:</strong>
            <span className="admit-date-value">{formatDate(student?.dob)}</span>
          </div>
          <div className="detail-item detail-item-full" style={{ marginTop: '-1.2em' }}>
            <strong>Exam Center:</strong>
            {examLocation || student?.exam_location || 'Not Mentioned'}
          </div>
        </div>

        <h6 className="admit-section-title">Exam Details</h6>
        <table className="exam-table">
          <colgroup>
            <col className="col-sr" />
            <col className="col-subject" />
            <col className="col-paper-type" />
            <col className="col-date" />
            <col className="col-time" />
          </colgroup>
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Subject Name</th>
              <th>Paper Type</th>
              <th>Exam Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {subjectRows.map((row, index) => (
              <tr key={`${row.subject}-${index}`}>
                <td>{index + 1}</td>
                <td>{row.subject}</td>
                <td>{row.paperType || ''}</td>
                <td className="admit-date-value">{row.date}</td>
                <td>{row.time}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="no-break admit-instructions">
          <h6 className="admit-section-title" style={{ marginTop: '14px' }}>
            Important Instructions
          </h6>
          <ol className="instruction-list text-start">
            <li>Student must carry this admit card to the exam hall.</li>
            <li>Reach the exam center at least 30 minutes before the exam time.</li>
            <li>No entry after exam starts.</li>
            <li>Carry valid ID proof (if required).</li>
            <li>No electronic gadgets allowed (mobile, smartwatch, etc.).</li>
            <li>Follow all examination rules and discipline.</li>
            <li>Any malpractice will lead to disqualification.</li>
          </ol>

          <div className="admit-footer">
            <div className="sign-box">Student Signature</div>
            <div className="sign-box-missing"> </div>
            <div className="sign-box">Authorized Signature (School Stamp)</div>
          </div>
        </div>
      </div>
    </>
  )
}
